import { Routes } from '@angular/router';
// import { DuePaymentsModule } from './layouts/due-payments/due-payments/due-payments.module';


export const routes: Routes = [
    {
        path:'',
        redirectTo:'',
        pathMatch:'full'
    },
    {
        path: '',
        loadChildren: () => import('./layouts/admin/admin.module').then((m) => m.AdminModule)
    },
    {
        path: '',
        loadChildren: () => import('./layouts/home-layout/home-layout.module').then((m) => m.HomeLayoutModule)
    },
    {
        path: '',
        loadChildren: () => import('./layouts/kyc-layout/kyc-layout.module').then((m) => m.KycLayoutModule)
    },
    {
        path: '',
        loadChildren: () => import('./layouts/nominee/nominee.module').then((m) => m.NomineeModule)
    },
    {
        path: '',
        loadChildren: () => import('./layouts/passbook-layout/passbook-layout.module').then((m) => m.PassbookLayoutModule)
    },
    {
        path: '',
        loadChildren: () => import('./layouts/profile-layout/profile-layout.module').then((m) => m.ProfileLayoutModule)
    },
    {
        path: '',
        loadChildren: () => import('./layouts/autopayment/autopayment.module').then((m) => m.AutopaymentModule)
    },

    {
        path: '',
        loadChildren: () => import('./layouts/due-payments/due-payments/due-payments.module').then((m) => m.DuePaymentsModule)
    },
    {
        path:'',
        loadChildren:() => import('./layouts/refer-earn/refer-earn.module').then((m) => m.ReferEarnModule)
    }

];
